import { CreditPackageSelectedState } from "@/global/store/data/purchaseCredit";
import { getUSCurrency } from "@/global/utils/getUSCurrency";
import { ActionModal } from "@/shared/base/components/ActionModal/ActionModal";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";
import {
  ModalCloseIcon,
  ModalTitleText,
} from "@/shared/base/components/ModalReusables/ModalReusables";
import { Box, Divider, Stack, Typography } from "@mui/material";
import MoneyVectorImage from "public/images/money_vector.png";

interface PurchaseCreditSuccessProps {
  amount?: number | null;
  text: string;
}
export function PurchaseCreditSuccess(props: PurchaseCreditSuccessProps) {
  if (!props.amount) return null;
  return (
    <Stack width={"100%"} height="100%" justifyContent={"center"} spacing={3}>
      <Stack alignItems={"center"} justifyContent={"center"}>
        <img
          src={MoneyVectorImage.src}
          alt={"money icon"}
          style={{
            width: "160px",
            height: "auto",
          }}
        />
      </Stack>
      <Stack alignItems={"center"} textAlign={"center"} spacing={1}>
        <Box>
          <Typography variant="h2" fontWeight={"700"} color={"text.primary"}>
            {getUSCurrency(props.amount)}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle1" color="text.secondary">
            {props.text}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
}

interface PurchaseCreditSuccessModalProps {
  isOpen: boolean;
  renderBody?: () => JSX.Element;
  onClose?: () => void;
}

export function PurchaseCreditSuccessModal(
  props: PurchaseCreditSuccessModalProps
) {
  return (
    <ActionModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      renderHeader={() => {
        return (
          <Stack py={2} px={3}>
            <Box>
              <ModalTitleText>Add Credit Success</ModalTitleText>
            </Box>
          </Stack>
        );
      }}
      renderBody={() => {
        return (
          <Box>
            <Divider />
            <Stack p={4} height={"450px"} alignItems={"center"}>
              {props?.renderBody?.()}
            </Stack>
            <Divider />
          </Box>
        );
      }}
      renderFooter={() => {
        return (
          <Stack alignItems={"flex-end"} py={2} px={3}>
            <Box width={"120px"}>
              <ModalActionButton variant="primary" onClick={props.onClose}>
                Close
              </ModalActionButton>
            </Box>
          </Stack>
        );
      }}
    />
  );
}
